import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { PayloadStates } from '@lore/utils';
import { InContextHelpMessage } from '@communityshare/ui-shared';
import { DialogManager } from '@/dialogs_new/DialogManager';
import useDialogLauncher from '@/dialogs-routable/_hooks/useDialogLauncher';
import useMissingFields from '@/pages/project-manage/useMissingFields';

ShareProjectCallout.propTypes = {
  project: PropTypes.shape({
    id: PropTypes.number.isRequired
  }).isRequired
};

export default function ShareProjectCallout(props) {
  const { project } = props;
  const { t } = useTranslation();
  const launch = useDialogLauncher();

  const { missingFields } = useMissingFields(project);

  // do not show this for projects with missing fields
  if (
    missingFields.state !== PayloadStates.RESOLVED ||
    missingFields.data.length > 0
  ) {
    return null;
  }

  return (
    <InContextHelpMessage
      boldText={t('projects.share.find_partners_callout_bold')}
      bodyText={t('projects.share.find_partners_callout_body')}
      linkLabel={t('projects.share.find_partners_share_link')}
      onLinkClick={() => launch(DialogManager.ProjectShare.Config(project.id))}
    />
  );
};
